<template>
  <div class="d-flex align-items-baseline ">
    <span class="mr-1">↕️</span>
    <input type="number" min="0" class="form-control" v-model="vertical" @input="input()">
    <span class="ml-2 mr-1">↔️</span>
    <input type="number" min="0" class="form-control" v-model="horizontal" @input="input()">
  </div>
</template>

<script>
export default {
  props: ['value','config'],

  data(){
    return {
      vertical:'0',
      horizontal:'0',
    }
  },
  mounted(){
      if(!this.value) return;
      var match = this.value.match(/^(\d+)px(?: (\d+)px)?$/);
      if(!match) return;
      this.vertical = match[1];
      this.horizontal = match[2] || match[1];
  },
  methods:{

    input(){
        var newval = this.vertical+'px '+this.horizontal+'px';
        this.$emit('change',newval);
    },

  }

}
</script>
